namespace Gamification.Gamification {
    export enum ApiScriptUtenteMostraEsperienzeEnum {
        Esperienze_Tutte = 1,
        Esperienze_Fruite = 2,
        Esperienze_Non_Fruite = 3
    }
    Serenity.Decorators.registerEnumType(ApiScriptUtenteMostraEsperienzeEnum, 'Gamification.Gamification.ApiScriptUtenteMostraEsperienzeEnum');
}
